export enum TableauDataType {
  Integer = 'DT_INTEGER',
  Real = 'DT_REAL',
  String = 'DT_STRING',
  DateTime = 'DT_DATETIME',
  Boolean = 'DT_BOOLEAN',
  Date = 'DT_DATE',
  Tuple = 'DT_TUPLE',
  Spatial = 'DT_SPATIAL',
  Binary = 'DT_BINARY',
  Time = 'DT_TIME',
  Table = 'DT_TABLE',
}
